export enum CalitatePersoana{
    PACIENT= "pacient",
    PARINTE="parinte",
    APARTINATOR_SOT="apartinator, sot",
    APARTINATOR_FRATE="apartinator frate/sora" ,
    TUTORE="tutore"
}

export class Persoana{
    numeSiPrenume: string;
    domiciliu: string;
    calitate: CalitatePersoana;
}

export enum BasicInfoFieldNames{
    basic_flowStatusField = "basic_flowStatusField",
    basic_tipPersoana = "basic_tipPersoana",
    basic_prenumePacient = "basic_prenumePacient",
    basic_numePacient = "basic_numePacient",
    basic_addrPacient = "basic_addrPacient",
    basic_dateOfBirthPacient = "basic_dateOfBirthPacient",
    basic_cnpPacient = "basic_cnpPacient",
    basic_prenumeLegalPers = "basic_prenumeLegalPers",
    basic_numeLegalPers = "basic_numeLegalPers",
    basic_addrLegalPers = "basic_addrLegalPers",
    basic_sex = "basic_sex",
    basic_phone = "basic_phone",
    basic_email = "basic_email",
    basic_clinic_name = "basic_clinic_name",
    basic_clinic_addr = "basic_clinic_addr",
    basic_clinic_email = "basic_clinic_email"
}
